import { EntityUpdater } from "./EntitiyUpdater";

export class StaffUpdater extends EntityUpdater {
    constructor(data, teamType) {
        super(data);
        this.teamType = teamType;
    }

    updateStaff(adding, deleting) {
        let { allMatchStaff } = this.data;

        if (deleting.length > 0) {
            allMatchStaff = this.processDeletions(deleting, allMatchStaff);
        }

        if (adding.length > 0) {
            allMatchStaff = this.processAdditions(
                adding,
                allMatchStaff,
                (item) => ({
                    contact: item.id,
                    dhbTeam: this.teamType,
                    contactName: `${item.firstName} ${item.lastName}`,
                    matchRole: 0,
                })
            );
        }

        this.data.allMatchStaff = allMatchStaff;
        this.data.isStaffChange = true;
        return this.data;
    }
}
